// api.js
/*
Токен сохраняется в HttpOnly cookie с именем authToken.
Функция fetchData добавляет токен в заголовок Authorization для всех запросов, если токен существует.
При невалидном userId очищается и authToken.
*/

import { getCookie } from './cookies';
import { SITE_CONFIG } from '../config/siteConfig';

export const fetchData = async (path, method, body) => {
  const url = `${SITE_CONFIG.apiBaseUrl}${path}`;
  const token = getCookie('authToken');
  const headers = {};
  if (!(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const options = {
    method,
    headers,
    body: body instanceof FormData ? body : body ? JSON.stringify(body, (key, value) => (value === undefined ? null : value)) : undefined,
    credentials: 'include',
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      let errorDetails = '';
      try {
        const errorBody = await response.json();
        errorDetails = JSON.stringify(errorBody);
      } catch (e) {
        errorDetails = '(не удалось прочитать тело ошибки)';
      }
      throw new Error(`Error ${response.status}. Request ${path}: ${errorDetails}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};
